import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useNotification from 'hooks/useNotification';

export default (error: any) => {
	const showNotification = useNotification();
	const { t } = useTranslation();

	useEffect(() => {
		if (error?.code === 426) {
			showNotification('error', t('errorPage.newVersionAvailable'));

			setTimeout(() => {
				window.location.reload();
			}, 2000);
		}
	}, [error]);
};
